// src/pages/B2B/event-reports/api/useReportEnv.ts
import { useEffect, useState } from 'react';
import type { Env } from '@/pages/Admin/shared';

const LS_KEY_ENV = 'eventReports.env';

/** Prod | Dev choice, remembered so the list and builder pages agree. */
export function useReportEnv(): [Env, (env: Env) => void] {
  const [env, setEnv] = useState<Env>(() => (localStorage.getItem(LS_KEY_ENV) as Env) || 'prod');
  useEffect(() => { localStorage.setItem(LS_KEY_ENV, env); }, [env]);
  return [env, setEnv];
}
